import React from 'react';
import {Doughnut} from 'react-chartjs-2';
import {connect} from "react-redux";
import PropTypes from "prop-types";

class OutsourceChart extends React.Component {

  constructor(props){
    super(props);

    this.state = {
      chartOptions: {
        responsive: true,
        tooltips: {
          enabled: true,
          callbacks: {
            label: function(tooltipItem, data) {
              //get the concerned dataset
              const dataset = data.datasets[tooltipItem.datasetIndex];
              //calculate the total of this data set
              const total = dataset.data.reduce(function(previousValue, currentValue, currentIndex, array) {
                return previousValue + currentValue;
              });
              //get the current items value
              const currentValue = dataset.data[tooltipItem.index];
              //calculate the precentage based on the total and current item, also this does a rough rounding to give a whole number
              const precentage = Math.floor(((currentValue/total) * 100)+0.5);

              return precentage + "%";
            }
          }
        },
        legend: false
      }
    };
  }

  render() {
    return (
      <Doughnut data={this.props.chartData} options={this.state.chartOptions} width={150} height={150}/>
    );
  }

}

const mapStateToProps = (state, ownProps) => {

  const chartData = {
    datasets: [{
      data: [],
      backgroundColor: [],
    }],
  };
  if (ownProps.stats){
    let totalValue = 0;
    ownProps.stats.forEach((stat) => {
      totalValue += stat.total;
      chartData.datasets[0].data.push(stat.total);
      chartData.datasets[0].backgroundColor.push('#' + stat.document_state.color);
    });
    if (totalValue === 0){
      chartData.datasets[0].data.push(1);
      chartData.datasets[0].backgroundColor.push('#9E9E9E');
    }
  }

  return({
    chartData: chartData,
  });
}


export default connect(mapStateToProps)(OutsourceChart);



OutsourceChart.propTypes = {
  stats: PropTypes.array,
};

OutsourceChart.defaultProps = {
};



// WEBPACK FOOTER //
// ./src/app/outsource/components/OutsourceChart.js